import { cloneDeep } from "lodash-es";
import { ResultRow } from "../../../data-structures/results/result-row.model";

interface CFOAInterface {
 'RESULTS.DATA.CASHFLOWS.NE'?: ResultRow;
 'RESULTS.DATA.CASHFLOWS.DAA'?: ResultRow;
 'RESULTS.DATA.CASHFLOWS.AI'?: ResultRow;
}
export class CFOA {
  'RESULTS.DATA.CASHFLOWS.NE';
  'RESULTS.DATA.CASHFLOWS.DAA';
  'RESULTS.DATA.CASHFLOWS.AI';
  /** net earnings */
  get ne() {
    return this['RESULTS.DATA.CASHFLOWS.NE'];
  }
  set ne(value: ResultRow) {
    this['RESULTS.DATA.CASHFLOWS.NE'] = value;
  }
  /** depreciation & amortization */
  get daa() {
    return this['RESULTS.DATA.CASHFLOWS.DAA'];
  }
  set daa(value: ResultRow) {
    this['RESULTS.DATA.CASHFLOWS.DAA'] = value;
  }
  get ai() {
    return this['RESULTS.DATA.CASHFLOWS.AI'];
  }
  set ai(value: ResultRow) {
    this['RESULTS.DATA.CASHFLOWS.AI'] = value;
  }

  constructor(param: CFOAInterface = {}) {
    this['RESULTS.DATA.CASHFLOWS.NE'] = param['RESULTS.DATA.CASHFLOWS.NE']
      ? new ResultRow(param['RESULTS.DATA.CASHFLOWS.NE'])
      : new ResultRow();

    this['RESULTS.DATA.CASHFLOWS.DAA'] = param['RESULTS.DATA.CASHFLOWS.DAA']
      ? new ResultRow(param['RESULTS.DATA.CASHFLOWS.DAA'])
      : new ResultRow();

    this['RESULTS.DATA.CASHFLOWS.AI'] = param['RESULTS.DATA.CASHFLOWS.AI']
      ? new ResultRow(param['RESULTS.DATA.CASHFLOWS.AI'])
      : new ResultRow();
  }

  deepCopy() {
    return new CFOA(cloneDeep(this));
  }
}